import { createBlueprint as a } from "@made-people/blueprint";
const r = a({
  slots: {
    base: "group flex items-center justify-center relative bg-background-surface-1",
    logo: "aspect-square object-contain w-full h-full",
    badge: "z-10 top-[var(--badge-padding)] right-[var(--badge-padding)]"
  },
  variants: {
    backgroundColor: {
      white: {
        base: "bg-background-page"
      },
      gray: {
        base: "bg-background-surface-1"
      }
    },
    size: {
      auto: {
        base: "p-2 rounded-lg [--badge-padding:8px] w-full"
      },
      sm: {
        base: "p-2 rounded-lg [--badge-padding:8px] w-full h-[80px]"
      },
      md: {
        base: "p-4 rounded-xl [--badge-padding:12px] w-full h-[72px]"
      },
      lg: {
        base: "p-6 rounded-xl [--badge-padding:24px] w-full h-[150px]"
      }
    },
    scaleOnHover: {
      true: {
        logo: "group-hover:scale-105 transition-transform"
      }
    }
  },
  defaultVariants: {
    size: { initial: "sm", md: "md" },
    scaleOnHover: "true"
  }
});
export {
  r as logoCardStyling
};
//# sourceMappingURL=index-blueprint.es.js.map
